import React, { useEffect, useRef } from "react";
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import { PowerSettingsNew } from "@mui/icons-material";

const UserMenu = ({ isOpen, onClose }) => {
  const userMenuRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();

  const handleClickOutside = (event) => {
    if (userMenuRef.current && !userMenuRef.current.contains(event.target)) {
      onClose();
    }
  };

  useEffect(() => {
    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen]);

  // Fixed menu items
  const menuItems = [
    {
      title: "Profile",
      icon: <HomeOutlinedIcon />,
      action: "profile",
    },
    {
      title: "Profile Setting",
      to: "/ProfileSetting",
      icon: <HomeOutlinedIcon />,
      action: "profileSetting",
    },
    {
      title: "Logout",
      to: "/Logout",
      icon: <PowerSettingsNew />,
      action: "logout",
    }    
  ];

  return (
    <Box
      ref={userMenuRef}
      sx={{
        position: "fixed",
        top: "64px",
        right: isOpen ? 0 : "-250px",
        width: "250px",
        height: "calc(100vh - 64px)",
        backgroundColor: "#fff",
        boxShadow: "0px 0px 10px rgba(0,0,0,0.2)",
        transition: "right 0.3s ease-in-out",
        zIndex: 1000,
        overflowY: "auto",
      }}
    >
      <Typography
        variant="h6"
        sx={{ p: 2, color: "#007bff", fontWeight: "bold" }}
      >
        Navigation
      </Typography>

      <List>
        {menuItems.map((item, index) => {
          const isActive =
            (item.action === "profile" && location.pathname === "/ViewUser") ||
            (item.action === "logout" && location.pathname === "/Logout");

          return (
            <ListItem
              button
              key={index}
              onClick={() => {
                onClose();

                // Handle Profile click
                if (item.action === "profile") {
                  const loggedUser = JSON.parse(
                    localStorage.getItem("loggedUser")
                  );

                  navigate("/ViewUser", {
                    state: { mode: "profile", user: loggedUser },
                  });
                }

                if (item.action === "profileSetting") {
                  navigate("/ProfileSetting");
                }

                // Handle Logout click
                if (item.action === "logout") {
                  navigate("/Logout");
                }
              }}
              sx={{
                backgroundColor: isActive ? "#007bff" : "transparent",
                color: isActive ? "#fff" : "text.primary",
                "&:hover": {
                  backgroundColor: "#007bff",
                  color: "#fff",
                },
                transition: "all 0.3s ease",
              }}
            >
              <ListItemIcon
                sx={{
                  color: isActive ? "#fff" : "text.secondary",
                  transition: "color 0.3s ease",
                }}
              >
                {item.icon}
              </ListItemIcon>

              <ListItemText primary={item.title} />
            </ListItem>
          );
        })}
      </List>
    </Box>
  );
};

export default UserMenu;
